<template>
  <div>
    <div>
      <div class="odmik-povezovanje-narocnin">
        <p class="navadno-besedilo"
           v-if="typeof seznamPrikljuckov.tip_prikljucka !== 'undefined' && seznamPrikljuckov[0].tip_prikljucka === 'OTT'">
          Povežite in upravljajte vse svoje naročnine. Za povezovano lahko uporabite obstoječe prijavne podatke, ki ste
          jih naročniki T-2 do sedaj uporabljali za prijavo v portal Horizont ali se odločite za povezavo naročnine z
          novimi podatki.
        </p>
        <p class="navadno-besedilo" v-else>
          Za dodajanje svojega naročniškega razmerja lahko uporabite obstoječe prijavne podatke, ki ste jih do sedaj
          uporabljali za prijavo v portal Horizont, ali se odločite za povezavo naročnine z novimi podatki.
        </p>
        <dodaj-obstojece :moznostVnosaSmsPotrditve="moznostVnosaSmsPotrditve"
                         v-on:posodobiTokenFormo="PosodobiMoznostSMS"
                         v-on:osveziPodatke="OsveziPodatke" />
        <div class="locilna-crta" v-if="!moznostVnosaSmsPotrditve">
          <span class="vmesno-besedilo">
            ALI
          </span>
        </div>
        <dodaj-novo :moznostVnosaSmsPotrditve="moznostVnosaSmsPotrditve"
                    v-on:posodobiTokenFormo="PosodobiMoznostSMS"
                    v-on:osveziPodatke="OsveziPodatke" />
      </div>
    </div>
    <div>
    </div>
      <div>
        <div style="clear: both" />
        <div>
          <div class="postavitev-info-dodajanje-narocnin">
            <InfoKomponentaDodajanjeNarocnin/>
          </div>
          <div class="zgornji-odmik-pomoc">
            <div id="bottom">
              <a :href=pomocObPovezovanjuNarocnine class="primarna-barva" target="_blank">
                <div class="postavitev-besedila-pomoc">
                  <p class="open-sans-13pt no-bold">
                  <span class="desni-pomik-texta-pomoc">
                    <b>
                      Potrebujete pomoč?
                    </b>
                  </span>
                    <br />
                    Imamo odgovore na pogosta vprašanja,
                    <br />
                    lahko nas tudi pokličete na 064 064 064.
                  </p>
                </div>
                <div class="desna-postavitev-ikone-pomoc">
                  <i class="fa fa-question-circle"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import {Input, Button, Collapse, CollapseItem, Col} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna'
import DodajObstojece from './DodajanjeNarocninKomponente/DodajObstojece'
import DodajNovo from './DodajanjeNarocninKomponente/DodajNovo'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import InfoKomponentaDodajanjeNarocnin from './DodajanjeNarocninKomponente/InfoKomponentaDodajanjeNarocnin.vue'

export default {
  name: 'DodajanjeNarocnin',
  mixins: [PrikazVsebine],
  data () {
    return {
      clientAgent: null,
      nosilecNarocnine: false,
      formaOrientacija: 'left',
      mejnaSirina: 600,
      moznostVnosaSmsPotrditve: false,
      pomocObPovezovanjuNarocnine: null
    }
  },
  components: {
    InfoKomponentaDodajanjeNarocnin,
    DodajNovo,
    DodajObstojece,
    [Button.name]: Button,
    [Input.name]: Input,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Col.name]: Col
  },
  props: {
    seznamPrikljuckov: null
  },
  mounted () {
    this.pomocObPovezovanjuNarocnine = povezave.BASE_URL_POMOC_OB_POVEZAVI_NAROCNINE
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    if (typeof this.$route.query.sapZacasni !== 'undefined') {
      this.DodajZacasnoNarocnino(this.$route.query.sapZacasni)
    }
  },
  methods: {
    DodajZacasnoNarocnino (sap) {
      this.$router.replace({'query': null})
      let param = ['sap=' + sap]
      this.clientAgent.postWsRequest(
        this,
        'subscriptions/addTemporarySubscription?',
        param,
        null,
        'DodajZacasnoNarocninoSuccess',
        'DodajZacasnoNarocninoError')
    },
    DodajZacasnoNarocninoSuccess () {
      window.location.reload()
    },
    DodajZacasnoNarocninoError (podatki) {
      this.ShowErrorMessage({'message': podatki.message})
    },
    PosodobiMoznostSMS (prikaziFormo) {
      this.moznostVnosaSmsPotrditve = prikaziFormo
    },
    OsveziPodatke () {
      this.$emit('osveziPodatke')
    }
  }
}
</script>

<style scoped src="../../../../../../static/css/Narocnine/DodajanjeNarocnin.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/DodajanjeNarocnin/DodajanjeNarocnin.vue